export const iconFontAwesomeDisasterCrisisVolcano = (
	<i className="fa-solid fa-volcano"></i>
);
